'use client'

import { type FC } from 'react'

import { SearchPageAdBanner } from '../components/SearchPageAdBanner'
import { type SearchPageAdBannerComponentProps } from '../components/SearchPageAdBanner/SearchPageAdBannerTypes'

import {
  SEARCH_PAGE_AD_BANNER_SEARCH_TOP,
  SEARCH_PAGE_AD_BANNER_SEARCH_TOP_DIMENSIONS,
} from './SearchPageAdBannerConfig'

export const SearchPageAdBannerTop: FC<SearchPageAdBannerComponentProps> = ({
  bannerClasses,
  className,
}) => (
  <SearchPageAdBanner
    bannerClasses={bannerClasses}
    bannerTags={[SEARCH_PAGE_AD_BANNER_SEARCH_TOP]}
    className={className}
    dimensions={SEARCH_PAGE_AD_BANNER_SEARCH_TOP_DIMENSIONS}
  />
)
